import { Component, OnInit, Input } from '@angular/core';
import { CartService } from 'src/app/services/api/cart.service';
import { environment as env } from "src/environments/environment";
import { BsModalService, BsModalRef, ModalOptions } from "ngx-bootstrap/modal";
import {
	FormArray,
	FormBuilder,
	FormGroup,
	Validators
} from "@angular/forms";
import * as $ from 'jquery';
import { TotebagArtworkComponent } from 'src/app/components/modals/totebag-artwork/totebag-artwork.component';
import { TshirtPrintLimitationComponent } from 'src/app/components/modals/tshirt-print-limitation/tshirt-print-limitation.component';
import { CmsService } from 'src/app/services/api/cms.service';
import { FbpixelService } from 'src/app/services/api/fbpixel.service';

@Component({
  selector: 'app-custom-canvas-tote-bag-options',
  templateUrl: './custom-canvas-tote-bag-options.component.html',
  styleUrls: ['./custom-canvas-tote-bag-options.component.scss']
})
export class CustomCanvasToteBagOptionsComponent implements OnInit {

	@Input() product:any = null;
	modalRef: BsModalRef;

	activeOpt:any = "";
	activeFW:any = {};

	numberPattern = /^([0-9]+$)/
	decimalPattern = /^(0|[1-9]\d*)(\.\d+)?$/

	selectedProductOptions:any = {
		size: null,
		print_location: {},
		front_print_size: {},
		back_print_size: {},
		do_not_merge: {}
	};
	selectedPrinteLocationNames:any = null;

	printMaxSize: any = null;
	printMaxWidth:any = '0';
	printMaxHeight:any = '0';

	setSelectedSizeValue: string = ''; /** this is used just for the marking of the radio buttons of the sizes option */

	formGroupQty: FormGroup;

	limitationHtmlContent: any = null

	constructor(
		public cartService: CartService,
		public formBuilder: FormBuilder,
		public modalService: BsModalService,
		public cms: CmsService,
		public fbpixel: FbpixelService
	) { }

	ngOnInit(): void {
		
		this.cms.getHndCmsPage('custom-canvas-tote-bag-limitation-modal-info', true, false).then(content => {
			this.limitationHtmlContent = content.content
		});

		this.formGroupQty = this.formBuilder.group({
			qty: ["", [Validators.required, Validators.pattern(this.numberPattern)]],
		});

		this.product['custom_block'] = JSON.parse(this.cartService.getData('custom_block', this.product));

		this.setOptions();
	}

	resetSelected(){
		this.setSelectedSizeValue = '';
		this.selectedProductOptions.size = null;

		this.selectedProductOptions.print_location = {};

		this.formGroupQty.controls.qty.reset();
		this.formGroupQty.reset();

		this.selectedPrinteLocationNames = null;

		this.setActiveOpt('');
	}

	setOptions(){
		this.printMaxSize = this.product.custom_block.print_size;

		this.product.options.forEach((option, optIndex) => {
			let optnTitle = option.title.toLocaleLowerCase();
			if(optnTitle == 'sizes'){
				option.values.forEach((optnVal, valIndex) => {
					optnVal["option_id"] = this.product.options[optIndex].option_id;
				});
			}
			else if(optnTitle == 'print location'){
			}
			else if(optnTitle == 'front print size' || optnTitle == 'back print size' || optnTitle == 'do not merge'){
				option["value"] = '';
				this.selectedProductOptions[optnTitle.split(' ').join('_')] = option;
			}
		});
	}

	setPrintLocationOption(){
		this.product.options.forEach((option, optIndex) => {
			let optnTitle = option.title.toLocaleLowerCase();
			if(optnTitle == 'print location'){
				option.values.forEach((optnVal, valIndex) => {
					let iconUrl = env.baseUrl + '/media/entrelabel/tote-bag-option-print-location/tote-bag.png';
					optnVal["icon_image"] = iconUrl;
					optnVal["max_width_value"] = this.printMaxWidth;
					optnVal["max_height_value"] = this.printMaxHeight;
					optnVal["option_id"] = this.product.options[optIndex].option_id;

					optnVal["form_group"] = this.formBuilder.group({
						width_value: ["", [Validators.required, Validators.pattern(this.decimalPattern), Validators.max(this.printMaxWidth)]],
						height_value: ["", [Validators.required, Validators.pattern(this.decimalPattern), Validators.max(this.printMaxHeight)]],
					});
				});
			}
		});
	}

	setActiveOpt(opt: any = "", collapse:boolean = true) {
		this.activeFW = {};

		if (this.activeOpt == opt) {
			if(collapse){
				this.activeOpt = "";
			} else {
				this.activeOpt = opt;
				this.activeFW[opt] = "fw-800";
			}
		} else {
			this.activeOpt = opt;
			this.activeFW[opt] = "fw-800";
		}
	}

	/** for sizes menu */

	setSelectedSize(e, size){
		e.preventDefault();

		this.selectedProductOptions.size = size;
		this.setSelectedSizeValue = size.option_type_id + '';
		
		let printSizeKey = this.selectedProductOptions.size.title;
		if(typeof this.printMaxSize[printSizeKey] != 'undefined'){
			this.printMaxWidth = this.printMaxSize[printSizeKey]['Back Print Size'].width.max;
			this.printMaxHeight = this.printMaxSize[printSizeKey]['Back Print Size'].height.max;
			this.setPrintLocationOption();
		}
	}

	get qtyErrors (){
		let getErrors = (errors:any, wh:string) => {
			let msg = '<p class="fc-red fs-10 mb-0 mt-5">';
			let msgArray = [];
			if(errors.required){
				msgArray.push(wh + ' is required');
			}
			if(errors.pattern){
				msgArray.push(wh + ' must be a valid number');
			}

			let strMsg = msgArray.join('. ');
			msg += strMsg.charAt(0).toUpperCase() + strMsg.slice(1);
			msg += '</p>';
			return msg;
		}

		let errorMessage = '';
		if(this.formGroupQty.controls.qty.touched && this.formGroupQty.controls.qty.status == 'INVALID'){
			errorMessage += getErrors(this.formGroupQty.controls.qty.errors, 'qty');
		}	
		return errorMessage;
	}

	/**
	 * print location option functions
	 */

	setSelectedPrintLocation(print_location){
		if(typeof this.selectedProductOptions['print_location']['_' + print_location.option_type_id] == 'undefined'){
			this.selectedProductOptions['print_location']['_' + print_location.option_type_id] = print_location;
		}
		else {
			delete this.selectedProductOptions['print_location']['_' + print_location.option_type_id];
		}

		let pl = Object.keys(this.selectedProductOptions.print_location);
		let selectedPLNames = [];
		pl.forEach(key => {
			selectedPLNames.push(this.selectedProductOptions.print_location[key].title);
		});
		this.selectedPrinteLocationNames = selectedPLNames.join(', ');
	}

	getPrintLocationFormErrors(formGroup:any){
		let getErrors = (errors:any, wh:string) => {
			let msg = '<p class="fc-red fs-10 mb-0 mt-5">';
			let msgArray = [];
			if(errors.required){
				msgArray.push(wh + ' is required');
			}
			if(errors.pattern){
				msgArray.push(wh + ' must be a valid number');
			}
			if(errors.max){
				msgArray.push('the maximum width can be printed is '+errors.max.max);
			}

			let strMsg = msgArray.join('. ');
			msg += strMsg.charAt(0).toUpperCase() + strMsg.slice(1);
			msg += '</p>';
			return msg;
		}

		let errorMessage = '';
		if(formGroup.controls.width_value.touched && formGroup.controls.width_value.status == 'INVALID'){
			errorMessage += getErrors(formGroup.controls.width_value.errors, 'width');
		}

		if(formGroup.controls.height_value.touched && formGroup.controls.height_value.status == 'INVALID'){
			errorMessage += getErrors(formGroup.controls.height_value.errors, 'height');
		}

		return errorMessage;
	}

	/**
	 * 
	 * Total
	 */
	pricePerBag = 0;
	get total(){
		let plPrice = this.totalPrintLocationPrice() + parseFloat(this.product.price);
		let qty = 0;
		if(this.formGroupQty.controls.qty.status == 'VALID'){
			qty = parseFloat(this.formGroupQty.controls.qty.value);
		}

		if(qty){
			let formula = this.product['custom_block'].price_formula.shipping_fee.split('{{qty}}').join(qty);
			let formulaResult = eval(formula);
			
			let tolalPrice = (plPrice * qty) + formulaResult;
			this.pricePerBag = tolalPrice / qty;
	
			return (plPrice * qty) + formulaResult;
		}
		else {
			return 0;
		}
	}

	totalPrintLocationPrice(){
		let p = 0;
		$.each(this.selectedProductOptions.print_location, (key, value) => {
			// if(value.form_group.status == 'VALID'){
				p += parseFloat(value.price);
			// }
		});
		if(this.selectedProductOptions.size){
			p += parseFloat(this.selectedProductOptions.size.price);
		}
		return p;
	}

	/** uppload art work and continue to add to cart */
	uploadArtWork(){
		let pl = Object.keys(this.selectedProductOptions.print_location);
		let canContinue = true;

		if(!this.selectedProductOptions.size){
			canContinue = false;
			this.cartService.toastService.add('Please select bag size', 'danger');
		}
		else if(!this.formGroupQty.controls.qty.value){
			canContinue = false;
			this.cartService.toastService.add('Please add bag qty', 'danger');
		}
		else if(!pl.length){
			canContinue = false;
			this.cartService.toastService.add('Please select print location', 'danger');
		}
		else {
			$.each(this.selectedProductOptions.print_location, (key, value:any) => {
				if(value.form_group.status == 'INVALID'){
					this.cartService.toastService.add('Please insert a valid print width and height for ' + value.title, 'danger');
					canContinue = false;
				}
				else {
					let optnTitle = value.title.toLocaleLowerCase() + '_print_size';
					let w = value.form_group.value.width_value + ' cm';
					let h = value.form_group.value.height_value + ' cm';
					this.selectedProductOptions[optnTitle].value = w + ' X ' + h;
				}
			});
		}

		setTimeout(() => {
			if(canContinue){
				this.fbPixel();

				let config: ModalOptions = {
					backdrop: "static",
					keyboard: false,
					animated: true,
					ignoreBackdropClick: true,
					initialState: {
						product: this.product,
						selectedProductOptions: this.selectedProductOptions,
						selectedQty: this.formGroupQty.controls.qty.value,
						selectedQtyPrice: this.total,
						awupload: "addtocart"
					}
				};

				this.modalRef = this.modalService.show(TotebagArtworkComponent, config);
				this.modalRef.setClass("custom-canvas-tote-bag-modal artwork-modal modal-dialog-centered");
				this.modalRef.content.onClose = (myData) => {
					this.modalRef.hide();
					this.fbPixel('AddToCart');

					if(typeof myData['item_id'] != 'undefined'){
						setTimeout(() => {
							this.resetSelected();
						}, 500);
					}
				};
			}
		}, 500);
	}

	openLimitationModal(type:string='limitation'){
		
		let cmsContent: any = this.limitationHtmlContent;
		let modalDialogClass = 'modal-dialog info-modal modal-dialog-centered product-info custom-canvas-tote-bag-modal';

		let config: ModalOptions = {
			backdrop: "static",
			keyboard: false,
			animated: true,
			ignoreBackdropClick: true,
			initialState: {
				cmsContent: cmsContent
			}
		};

		this.modalRef = this.modalService.show(TshirtPrintLimitationComponent, config);
		this.modalRef.setClass(modalDialogClass);
		this.modalRef.content.onClose = (myData) => {
			this.modalRef.hide();
		};
	}

	/**
	 * the pixel here is only for ViewContent event
	 * @param event 
	 */
	fbPixel(event = 'ViewContent'){

		let price = this.pricePerBag;

		if(price > 0){
			let fbqData = {
				content_name: this.product.sku,
				content_category: 'Default',
				content_ids: [this.product.id],
				content_type: 'product',
				value: price,
				currency: 'PHP'
			}
			this.fbpixel.fbq('track', event, JSON.parse(JSON.stringify(fbqData)));
	
			let ttqData = {  
				contents: [
					{
						content_id: this.product.id + '',
						content_name: this.product.sku,
						quantity: this.formGroupQty.controls.qty.value,
						price: price,
					}
				],
				content_type: 'product',
				value: this.total,
				currency: 'PHP',  
			}
			this.fbpixel.ttq(event, JSON.parse(JSON.stringify(ttqData)));
		}
	}
}
